/**
 * 学習データを保持するクラス
 */
export default class TrainData {
    /**
     * 生データ\
     * 最後にアップロードした学習データ取得APIのレスポンスを想定しています。
     */
    private _rawData: any[];

    /**
     * 利用データ
     */
    private _data: any[];

    /**
     * コンストラクタ
     * @param rawData 生データ
     */
    constructor(
        rawData: any[],
        inputDataHeaders: any[],
        public readonly selectedCase: string | null = null,
        public readonly selectedId: string | null = null,
        public readonly selectedLanguage: string | null = null,
    ) {
        this._rawData = rawData;

        const data = [...rawData];
        // ヘッダの数が異なるケース
        // ・indexで重複があり、サーバー側で追加している
        // 一番左のデータが追加されているので削除
        if (data[0].length != inputDataHeaders.length) {
            for (let i = 0; i < data.length; i++) {
                data[i].shift();
            }
        }
        // 同名ヘッダーがあるとサーバー側で名前に.1(ドット+数字)が付与されるので、
        // フロントでは入力データのヘッダを使用する
        data[0] = inputDataHeaders;

        this._data = data;
    }

    /**
     * getter 学習データ取得
     */
    public get data(): any[] {
        return this._data;
    }

    public get labelName(): string {
        const last_index = this._data[0].length - 1;
        return this._data[0][last_index];
    }
}
